<template>
    <rkm-overlay :show="loading">
        <rkm-form
            @success="handleLogin"
            class="login-form"
            ref="RkmForm"
            validate-on-submit
        >
            <h2>Bem-vindo de volta</h2>
            <p class="subtitle">Faça login em sua conta para continuar</p>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.login"
                        autocomplete="username"
                        name="Usuário"
                        placeholder="Digite seu usuário"
                        v-model="model.login"
                    >
                        <rkm-input-group-prepend slot="prepend">
                            <rkm-input-group-text>
                                <rkm-icon :icon="['far', 'user']" />
                            </rkm-input-group-text>
                        </rkm-input-group-prepend>
                    </rkm-form-input>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.senha"
                        autocomplete="current-password"
                        name="Senha"
                        placeholder="Digite sua senha"
                        type="password"
                        v-model="model.senha"
                    >
                        <rkm-input-group-prepend slot="prepend">
                            <rkm-input-group-text>
                                <rkm-icon icon="lock" />
                            </rkm-input-group-text>
                        </rkm-input-group-prepend>
                    </rkm-form-input>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <div class="login-form-actions">
                        <rkm-row>
                            <rkm-col>
                                <rkm-button
                                    :disabled="loading"
                                    block
                                    color="primary"
                                    type="submit"
                                >
                                    Entrar
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-link :to="{name: 'recuperar-senha'}">
                                    Esqueceu sua senha?
                                </rkm-link>
                            </rkm-col>
                        </rkm-row>
                    </div>
                </rkm-col>
            </rkm-row>
        </rkm-form>
    </rkm-overlay>
</template>

<script>
// Mixins.
import {error, notification} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('autenticacao-login-form')
        },
         validations() {
            return {
                login: {required: true},
                senha: {required: true},
            }
        },
    },
    data: () => ({
        model: {
            login: null,
            senha: null,
        },
    }),
    inject: ['repositories'],
    methods: {
        ...mapActions([
            'clearLocalStorage',
            'setDatetime',
            'setExpiration',
            'setLoading',
            'setModulos',
            'setSidebar',
            'setToken',
            'setUsuario',
            'unsetLoading',
        ]),
        handleLogin() {
            this.$refs.RkmForm.validate()
                .then(validated => {
                    if (validated === true) {
                        this.setLoading('autenticacao-login-form')

                        this.repositories.autenticacao.login(this.model)
                            .then(({data}) => {
                                this.setExpiration(data.expiration)
                                this.setModulos(data.modulos)
                                this.setSidebar(true)
                                this.setToken(data.token)
                                this.setUsuario(data.usuario)

                                if (data.usuario.troca_senha === true) {
                                    this.$router.push({name: 'trocar-senha'})
                                } else {
                                    this.$router.push({name: 'dashboard'})
                                }
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading('autenticacao-login-form'))
                    }
                })
        },
    },
    mounted() {
        this.clearLocalStorage()
    },
    mixins: [error, notification],
}
</script>